
angular.module('bmsApp.crm.prospect').factory('ProspectStatusSvc', function (CRUDSvc, PROSPECT_STATUS_API) {

	return {
		options: function () {
			return CRUDSvc.get(PROSPECT_STATUS_API.OPTIONS);
		}
	};

}).constant('PROSPECT_STATUS_API', {
	OPTIONS: 'api/prospectStatus/options'
});
